<html>

    <head>
       
    </head>

    <body class="dx-viewport">
        <!------------------------------------------------------------------------->
        <dx-box
            direction="row"
            width="100%"
            [height]="formheight"
        >
            <!------------------------------------------------------------------------->
            <dxi-item
                [ratio]="4"
                class="rectangleinfosquare"
            >   
                <!------------------------------------------------------------------------->
                <dx-scheduler
                    #scheduleragenda
                    id="scheduleagenda"

                    [dataSource]="subscriptionschedulerlist"

                    [views]="['agenda']"
                    currentView="agenda"

                    [startDayHour]="8"
                    height="98%"

                    (onContentReady)="onContentReadyAgenda($event)"
                    [customizeDateNavigatorText]="customizeAgendaDateNavigatorText"

                    (onAppointmentTooltipShowing)="onAppointmentTooltipShowing($event, 1)"
                    (onAppointmentClick)="onAgendaAppointmentClick($event)"
                    (onAppointmentDblClick)="onAgendaAppointmentDblClick($event)"

                    appointmentTemplate="appointment-agendatemplate"
                >
                    <!------------------------------------------------------------------------->
                    <dxi-view
                        type="agenda"
                        [agendaDuration]="agendaageduration"
                        dateCellTemplate="agendadateCellTemplate"
                
                     >
                    </dxi-view>
                    <!------------------------------------------------------------------------->
                    <div *dxTemplate="let data of 'agendadateCellTemplate'">
                        <div class="fontsize12">
                            {{data.date | date: 'EEEE' }} 
                            <br>
                            {{data.date | date: dateformat}}
                        </div>
                    
                    </div>
                    <!------------------------------------------------------------------------->
                    <div *dxTemplate="let modelagenda of 'appointment-agendatemplate'">

                        {{modelagenda.targetedAppointmentData.title}}
                        <br>
                        {{modelagenda.targetedAppointmentData.startDate | date:'shortTime'}}-{{modelagenda.targetedAppointmentData.endDate | date:'shortTime'}}
                    
                    </div>
                    <!------------------------------------------------------------------------->
                </dx-scheduler>
            
            </dxi-item>
            <!------------------------------------------------------------------------->
            <dxi-item
                [ratio]="12"
                class="rectangleinfosquare"
            >   
                <dx-scheduler
                    #scheduler
                    id="scheduler"

                    [dataSource]="subscriptionschedulerlist"

                    [views]="['day', 'week','timelineWeek','month','timelineMonth' ]"
                    [(currentView)]="scheduleview"

                    [currentDate]="currentDate"
          
                    [startDayHour]="8"
                    height="98%"

                    (onAppointmentFormOpening)="onAppointmentFormOpening($event)"

                    (onAppointmentAdding)="onAppointmentAdding($event)"
                    (onAppointmentUpdated)="onAppointmentUpdated($event)"

                    appointmentTooltipTemplate="tooltip-template"
                >
                    <!------------------------------------------------------------------------->
                    <dxo-scrolling mode="virtual"> </dxo-scrolling>
                    <!------------------------------------------------------------------------->
                    <dxi-view
                        type="day"
                        appointmentTemplate="appointmentday-template"
                    >
                    </dxi-view>

                    <div *dxTemplate="let data of 'appointmentday-template'"  style="width: 90%;" >

                        <div style="display: flex">
                       
                            <dx-text-box
                                label="Subject"
                                [readOnly]="true"
                                [value]="data.appointmentData.title"
                                width="70%"
                                height="20px"
                                [elementAttr]="{ class: 'margin10' }">
                            >
                            </dx-text-box>

                            <dx-text-box
                                label="Time"
                                [readOnly]="true"
                                value="{{data.targetedAppointmentData.startDate | date:'shortTime'}}-{{data.targetedAppointmentData.endDate | date:'shortTime'}}"
                                width="15%"
                                height="20px"
                            >
                            </dx-text-box>

                            <dx-button
                                icon="trash"
                                stylingMode="text"
                                [elementAttr]="{ class: 'elementright' }"
                                (onClick)="onDeleteButtonClick($event,  data.appointmentData)"
                            >
                            </dx-button>
                        

                        </div>

                    </div>
                    <!------------------------------------------------------------------------->
                    <dxi-view
                        type="week"
                        appointmentTemplate="appointmentweek-template"
                        dateCellTemplate="dateCellWeekTemplate"
                    >
                    </dxi-view>

                    <dxi-view
                        type="timelineWeek"
                        appointmentTemplate="appointmenttimelineweek-template"  
                        dateCellTemplate="dateCellWeekTemplate"
                    >
                    </dxi-view>

                    <div *dxTemplate="let data of 'appointmentweek-template'">

                        <div style="font-size:10px;">
                            {{data.targetedAppointmentData.startDate | date:'shortTime'}} -
                            <br>
                            {{data.targetedAppointmentData.endDate | date:'shortTime'}}
                        </div>
                      
                    </div>

                    <div *dxTemplate="let data of 'dateCellWeekTemplate'">

                        <div style="font-size:10px;">
                            {{data.date | date: 'EEEE' }} 
                            <br>
                            {{data.date | date: dateformat}}
                        </div>
                      
                    </div>
                    
                    <div *dxTemplate="let data of 'appointmenttimelineweek-template'" style="width: 100%;">

                        <div style="display: flex;font-size: 10px">

                            <div style="border: 2px solid white;width: 60%;  margin-right: 5px;">
                                {{data.targetedAppointmentData.startDate | date: 'EEEE' }} &nbsp; {{data.targetedAppointmentData.startDate  | date: dateformat}} &nbsp;

                            </div>
                           
                            <div style="border: 2px solid white;width: 100%; text-align: right;">
                                    {{data.targetedAppointmentData.startDate | date:'shortTime'}}-{{data.targetedAppointmentData.endDate | date:'shortTime'}}
                            </div>
                        
                        </div> 

                        <div style="font-size: 10px; border: 2px solid white;width: 100%; margin-top: 2px;">
                            {{data.appointmentData.title}} 
                        </div>

                    </div>
                    <!------------------------------------------------------------------------->
                    <dxi-view
                        type="month"
                        appointmentTemplate="appointmentmonth-template"
                        [maxAppointmentsPerCell]="2"
                    >
                    </dxi-view>

                    <dxi-view
                        type="timelineMonth"
                        appointmentTemplate="appointmentimelineMonth-template"
                        dateCellTemplate="dateCelltimelineMonthTemplate"    
                    >
                    </dxi-view>

                    <div *dxTemplate="let data of 'appointmentmonth-template'">

                        <div style="font-size:8px;">
                            {{data.targetedAppointmentData.startDate | date:'shortTime'}}-{{data.targetedAppointmentData.endDate | date:'shortTime'}}
                            <br>
                            {{data.appointmentData.title}}
                        </div>

                    </div>

                    <div *dxTemplate="let data of 'appointmentimelineMonth-template'" style="width: 100%;">

                        <div style="font-size:10px;border: 2px solid white;width: 100%; margin-bottom: 2px;">
                                {{data.targetedAppointmentData.startDate | date:'shortTime'}}- {{data.targetedAppointmentData.endDate | date:'shortTime'}}
                        </div>

                        <div style="font-size:10px;border: 2px solid white;width: 100%">
                            {{data.appointmentData.title}}
                        </div> 
                    
                    </div>

                    <div *dxTemplate="let data of 'dateCelltimelineMonthTemplate'">

                        <div style="font-size:10px;">
                            {{data.date | date: 'EEEE' }} 
                            <br>
                            {{data.date | date: dateformat}}
                        </div>
                      
                    </div>


                    <!------------------------------------------------------------------------->
                    <div *dxTemplate="let data of 'tooltip-template'" style="width: 100%;">

                        <div style="display: flex">

                            <div class="scheduleSubject">
                                <dx-text-box
                                    label="Subject"
                                    [readOnly]="true"
                                    [value]="data.appointmentData.title"
                                    width="90%"
                                    height="20px"
                                >
                                </dx-text-box>
                            </div>
                            <!------------------------------------------------------------------------->
                            <ng-container>
                                <div *ngIf="scheduleview != 'day'; then thenBlock"></div>

                                <ng-template #thenBlock>   
                                    <div>

                                        <dx-button
                                            icon="trash"
                                            stylingMode="text"
                                            (onClick)="onDeleteButtonClick($event,  data.appointmentData)"
                                        ></dx-button>

                                    </div>

                                </ng-template>    

                            </ng-container>
                            <!------------------------------------------------------------------------->
                        </div>

                        <div class="scheduleToolTip">

                            <dx-text-area
                                label="Notes"
                                [(value)]="data.appointmentData.description"
                                [autoResizeEnabled]="true"
                                width="100%"
                                [readOnly]="true"
                            >
                            </dx-text-area>
                        </div>
                        

                    </div>
                    <!------------------------------------------------------------------------->
            
                </dx-scheduler>
                <!------------------------------------------------------------------------->
            </dxi-item>
            <!------------------------------------------------------------------------->
        </dx-box>
        <!------------------------------------------------------------------------->
    </body>

</html>
